
<template>
  <div class="cfs-receiving-container">
    <div class="cfs-receiving">
      <p class="title">CFS Receiving</p>
      <!--      <form >-->
      <div class="form-group">
        <label for="input">Input <span style="color: red">*</span></label>
        <div style="height: 50px">
          <input
              type="text"
              id="input"
              v-model="input"
              @keyup.enter.prevent="handleInputSplit"
              @blur="handleInputSplit"
          />
          <p style="color: red"  v-if="verifyInput">{{inputErrorMessage}}</p>
        </div>
      </div>

      <div class="form-group"  v-if="false" >
        <label for="orderNumber">SO No</label>
        <input type="text" id="orderNumber" v-model="orderNumber" disabled/>
      </div>

      <div class="form-group"  v-if="false">
        <label for="shipment">Seq</label>
        <input type="text" id="shipment" v-model="shipment" disabled />
      </div>

      <div class="form-group">
        <label for="containerCount">Number of Carton <span style="color: red">*</span></label>
        <div style="height: 50px">
          <input
              type="number"
              id="containerCount"
              ref="containerCountRef"
              v-model.number="containerCount"
              @keyup.enter.prevent="handleSubmit"
              @keydown="preventDecimal"
              @blur="containerCountChange"
          />
          <p style="color: red" v-if="verifyContainerCount">Only valid integers can be entered</p>
        </div>

      </div>

      <!--      <div class="form-group" style="padding: 0 ;margin-bottom: 0px;">-->
      <!--        <label></label>-->
      <!--      -->
      <!--      </div>-->

      <button type="submit" class="submit-btn" @click="handleSubmit">Submit</button>
      <!--      </form>-->
    </div>
  </div>
</template>

<script>import ajax from "@/api/ajax";
import axios from "axios";


export default {
  data() {
    return {
      verifyInput : false,
      verifyContainerCount : false,
      input: null,
      orderNumber: null,
      shipment: null,
      containerCount: null,
      inputErrorMessage: null,
    };
  },
  methods: {
    containerCountChange(){
      this.verifyContainerCount = this.verifyContainerCountMethod();
      return;
    },

    verifyInputMethod() {
      let flag = false;
      if (this.input === null || this.input === undefined || this.input === '') {
        this.inputErrorMessage = "Input cannot be empty";
        flag = true;
      } else if (!this.input.includes('~')) {
        this.inputErrorMessage = "Input format is incorrect, missing ~";
        flag = true;
      } else if ((this.input.match(/~/g) || []).length !== 3) {
        this.inputErrorMessage = "Input must contain exactly three ~ characters";
        flag = true;
      } else if (this.input.indexOf('~') === 0 || this.input.lastIndexOf('~') === this.input.length - 1) {
        this.inputErrorMessage = "Input format is incorrect, ~ cannot be at the beginning or end";
        flag = true;
      } else {
        // 检查分割后的所有部分是否都非空
        const parts = this.input.split('~');
        for (let i = 0; i < parts.length; i++) {
          if (parts[i].trim() === '') {
            this.inputErrorMessage = "Input format is incorrect, all parts must be non-empty";
            flag = true;
            break;
          }
        }
        if (!flag) {
          flag = false;
        }
      }
      return flag;
    },


    verifyContainerCountMethod(){
      let flag = false;
      if (this.containerCount === null || this.containerCount === undefined || this.containerCount === '') {
        flag =  true;
      } else if (!Number.isInteger(this.containerCount) || this.containerCount <= 0) {
        flag = true;
      } else {
        flag =  false;
      }
      return  flag;
    },
    // 阻止小数点输入，只允许整数
    preventDecimal(event) {
      // 阻止小数点键（keyCode 190 和 110）
      if (event.keyCode === 190 || event.keyCode === 110) {
        event.preventDefault();
      }
    },

    handleInputSplit() {
      this.verifyInput = this.verifyInputMethod();
      if (this.verifyInput){
        this.orderNumber = null;
        this.shipment = null;
        return;
      }
      if (this.input) {
        // if (this.input.includes('~')){
        //   const parts = this.input.split('~');
        //   this.orderNumber = parts[0];
        //   this.shipment = parts[1];
        // }else {
        //   this.orderNumber = this.input;
        //   this.shipment = null;
        // }
        this.$nextTick(() => {
          this.$refs.containerCountRef.focus();
        });
      }else {
        // this.orderNumber = null;
        // this.shipment = null;
      }
    },
    handleSubmit(){
      this.verifyContainerCount = this.verifyContainerCountMethod();
      this.verifyInput = this.verifyInputMethod();
      if (this.verifyContainerCount || this.verifyInput){
        return;
      }

      let ajaxurl = ajax.ajaxUrl();
      let that = this
      axios.get(ajaxurl + "/report/generic/print/cfsReceiving", {
        params: {
          name: 'Cfs_Receiving_Label',
          code: 'Cfs_Receiving_Label',
          input: this.input,
          // orderNumber:  this.orderNumber,
          // shipment: this.shipment,
          containerCount: this.containerCount,
        },
        // headers: {
        //   Authorization: cookie.getBearerToken()
        // },
        responseType: "blob" //二进制流
      }).then(res=>{
        that.pubPdfMsgfn(res)
      })
    },
    // paf接口返回值处理
    pubPdfMsgfn(res){
      let data = res.data;
      let fileReader = new FileReader();
      let that = this
      fileReader.onload = function() {
        try {
          let jsonData = JSON.parse(this.result);
          if (jsonData.code) {
            that.$customMessage.warning(jsonData.msg);
            that.$store.commit("updataLoading", { pbLoading: false });
            that.isBtnajax = false
          }
        } catch (err) {
          that.pubPdfUploadOk(res);
        }
      };
      fileReader.readAsText(data);
    },
    //pdf 成功下载方法
    pubPdfUploadOk(data){
      this.isBtnajax = false
      this.$store.commit("updataLoading", { pbLoading: false });
      let blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
      let url = window.URL.createObjectURL(blob);
      window.open(url);
    },
  }
}
</script>

<style scoped lang="less">.cfs-receiving-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #f0f0f0;
}

.cfs-receiving {
  padding: 30px;
  font-family: Arial, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 10px;
  transform: scale(1.5);
  transform-origin: center center;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  .title {
    margin-bottom: 25px;
    text-align: left;
    color: #333;
    font-size: 18px;
    font-weight: bold;
    width: 100%;
    padding-left: 0;
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .form-group {
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 5px 0;

    label {
      margin-bottom: 0;
      margin-right: 20px;
      font-weight: bold;
      width: 180px;
      text-align: left;
      color: #555;
      font-size: 14px;
    }

    input {
      padding: 10px 12px;
      border: 1px solid #ccc;
      border-radius: 6px;
      width: 450px;
      font-size: 14px;
      transition: border-color 0.3s, box-shadow 0.3s;

      &:focus {
        outline: none;
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
      }
    }

    input[disabled] {
      background-color: #f8f8f8;
      cursor: not-allowed;
      color: #999;
    }
  }

  .submit-btn {
    padding: 12px 24px;
    font-size: 16px;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 6px;
    cursor: pointer;
    width: 300px;
    margin-top: 25px;
    transition: all 0.3s;
    font-weight: bold;
    color: #333;

    &:hover {
      background-color: #e0e0e0;
      border-color: #999;
      transform: translateY(-2px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    &:active {
      transform: translateY(0);
    }
  }
}
</style>